import { GeneratedPalette } from '@/pages/branding/sections/generatedPalette/GeneratedPalette.tsx'
import { EditOutlined } from '@ant-design/icons'
import { Button, Col, ColorPicker, Row } from 'antd'
import { Color } from 'antd/es/color-picker'
import React, { ComponentProps } from 'react'

interface Props {
  value: string
  onChange: (color: Color) => void
  generatedPalette?: ComponentProps<typeof GeneratedPalette>['type']
}

export const SettingsColorPicker: React.FC<Props> = ({ value, onChange, generatedPalette }) => (
  <ColorPicker
    value={value}
    onChange={(color) => onChange(color)}
    disabledAlpha
    panelRender={(panel) => (
      <>
        <Row style={{ marginBottom: generatedPalette ? 12 : 0 }}>
          <Col style={{ flexGrow: 1 }}>{panel}</Col>
        </Row>

        {generatedPalette && <GeneratedPalette type={generatedPalette} reversed />}
      </>
    )}
  >
    <Row>
      <Col style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '25px', height: '25px', borderRadius: '2px', background: value }} />
      </Col>

      <Col>
        <Button type="link" className="adsp-button" htmlType="button">
          <EditOutlined /> Edit color
        </Button>
      </Col>
    </Row>
  </ColorPicker>
)
